import React from 'react';

import {
  getPropertyConditionClause,
  REPAIRS_LEAD_IN,
} from '@/utils/propertyConditionClause';

interface Props {
  sellerName?: string;
  buyerName?: string;
  propertyCondition?: string;
  // Use seller property info if available, otherwise fall back to agent property info
  propertyAddress?: string;
  propertyCounty?: string;
  propertyCity?: string;
  propertyState?: string;
  propertyZipCode?: string;
  legalDescription?: string;
  /** "Subject To" conditions and the buyer's requested repairs (offer specifics). */
  subjectTo?: string;
  additionalSubjectTo?: string;
  requestedRepairs?: string;
}

const PropertyInfo: React.FC<Props> = ({
  legalDescription,
  propertyCondition,
  propertyCounty,
  propertyAddress,
  propertyCity,
  propertyState,
  propertyZipCode,
  subjectTo,
  additionalSubjectTo,
  requestedRepairs,
}) => {
  const { statement, repairs } = getPropertyConditionClause({
    propertyCondition,
    subjectTo,
    additionalSubjectTo,
    requestedRepairs,
  });
  return (
    <>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        PROPERTY INFORMATION
      </h2>
      <ol className=" list-decimal ml-4">
        <li>
          By this agreement Seller agrees to sell and Buyer agrees to buy the
          real property located at:{' '}
          <span className="font-semibold">{propertyAddress}</span>
        </li>
        <li>
          The Property is located in:{' '}
          <span className="font-semibold">
            {propertyCity || propertyCounty
              ? `${propertyCity || propertyCounty}, `
              : ''}
            {propertyState} {propertyZipCode}
          </span>
        </li>

        <li>
          The Property is legally described as follows:{' '}
          <span className="font-semibold">{legalDescription}</span>
        </li>

        <li>
          <span className="font-semibold">{statement}</span>
          {repairs.length > 0 && (
            <ol className="list-[lower-alpha] ml-6 mt-1">
              <li>
                Seller shall complete the following repairs, in a workmanlike
                manner, prior to Settlement:
                <ul className="list-disc ml-6">
                  {repairs.map((r) => (
                    <li key={r} className="font-semibold">
                      {r}
                    </li>
                  ))}
                </ul>
              </li>
            </ol>
          )}
        </li>
      </ol>
    </>
  );
};

export default PropertyInfo;
